import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import slice from 'lodash/slice';
import { Row, Col } from 'reactstrap';
import { Link } from 'gatsby';
import { animateScroll, scroller, Element } from 'react-scroll';

import LoadMore from 'components/loadMore';
import { Title } from 'components/typography';
import PlaceholderImage from 'assets/images/updates/placeholder.png';
import { useUpdates } from 'context/updates';

import { ClockIcon } from '../icons';
import { filterPosts } from './UpdatesList.helpers';
import { POSTS_PER_PAGE } from './UpdatesList.constants';

import {
  updateRow,
  updateCol,
  update,
  updateImg,
  updateOverlay,
  updateDate,
  updateText,
  updateLink,
  exploreLink,
  updateTitleBebas,
  updateTitleRegular,
} from './scss/UpdatesList.module.scss';

const UpdatesList = ({ filter }) => {
  const updates = useUpdates();
  const [currPage, setCurrPage] = useState(1);
  const activeList = filterPosts(updates, filter);
  const hasShownAll = activeList.length < POSTS_PER_PAGE * currPage;
  const collapseUpdates = () => {
    setTimeout(() => {
      setCurrPage(1);
    }, 600);
    animateScroll.scrollToTop({ smooth: true });
  };
  const loadMoreUpdates = () => {
    setCurrPage(currPage + 1);
    scroller.scrollTo('loadMore', { smooth: true, offset: -120 });
  };

  useEffect(() => {
    collapseUpdates();
  }, [filter]);

  return (
    <section>
      <Element name="updatesTop" />
      <Row className={updateRow}>
        {slice(activeList, 0, currPage * POSTS_PER_PAGE).map(item => {
          return (
            <Col
              lg={item.featured ? '6' : '3'}
              key={shortid()}
              className={updateCol}
            >
              <div className={update}>
                <img
                  src={item.jetpack_featured_media_url || PlaceholderImage}
                  alt={item.title}
                  className={updateImg}
                />
                <div className={updateOverlay}>
                  <Link to={item.slug} className={exploreLink}>
                    EXPLORE
                  </Link>
                </div>
                <div className={updateText}>
                  <Link to={item.slug} className={updateLink}>
                    <Title
                      renderAsHtml
                      value={item.title}
                      className={
                        item.featured ? updateTitleBebas : updateTitleRegular
                      }
                      fontStyle={item.featured ? 'bebas' : 'regular'}
                      size={item.featured ? 'md' : 'xs'}
                    />
                  </Link>
                  <p className={updateDate}>
                    <ClockIcon /> {item.date}
                  </p>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>

      <Element name="loadMore">
        <LoadMore
          isVisible={activeList.length > POSTS_PER_PAGE}
          label={hasShownAll ? 'Collapse Updates' : `More Updates`}
          onClick={hasShownAll ? collapseUpdates : loadMoreUpdates}
          arrowDirection={hasShownAll ? 'up' : 'down'}
        />
      </Element>
    </section>
  );
};

UpdatesList.propTypes = {
  filter: PropTypes.string,
};

export default UpdatesList;
